import gql from 'graphql-tag'

export const CONTACTS_AND_SYSTEM_USERS_REPORT = gql`
    query {
        reportContactsAndSystemUsers
    }
`
